import { ILookupItem } from "../interfaces";

export class LookupItemModel<TValue> implements ILookupItem {

    /**
     * The unique identifier for the lookup item.
     */
    public id: string;

    /**
     * The name/label for the lookup item.
     */
    public name: string;

    /**
     * The value for the lookup item.
     */
    public value?: TValue;

    /**
     * The translation key for the lookup item.
     */
    public translateKey?: string;

    /**
     * Constructor.
     * @param id The unique identifier for the lookup item.
     * @param name The name/label for the lookup item.
     * @param value The value for the lookup item.
     * @param translateKey The translation key for the lookup item.
     */
    constructor(id: string, name: string, value?: TValue, translateKey?: string) {
        this.id = id;
        this.name = name;
        this.value = value;
        this.translateKey = translateKey;
    }

}
